<template>
    <el-tag :type="type" size="mini">{{ code }}</el-tag>
</template>

<script>

export default {
  props: ["code"],
  computed: {
    type() {
      if (this.code >= 200 && this.code < 400) {
        return "success";
      } else if (this.code >= 400 && this.code < 500) {
        return "warning";
      } else if (this.code >= 500) {
        return "danger";
      } else {
        return "primary";
      }
    }
  }
};

</script>